import React, { useState } from "react";
import ChangePasswordForm from "./ChangePasswordSteps/ChangePasswordForm";
import ChangePasswordConfirmation from "./ChangePasswordSteps/ChangePasswordConfirmation";
import {
    ModalOverlay,
    ModalBody,
    ModalHeader,
    ModalHeaderTitle,
    ModalHeaderCloseButton,
} from "../../Util/Modal.elements";

const ChangePasswordGroup = (props) => {
    const [step, setStep] = useState("form");

    return (
        <ModalOverlay open={props.show} onClose={props.handleClose} fullWidth>
            <ModalBody>
                <ModalHeader $marginBottom={28}>
                    <ModalHeaderTitle>CHANGE PASSWORD</ModalHeaderTitle>
                    <ModalHeaderCloseButton type="button" onClick={props.handleClose}>
                        &times;
                    </ModalHeaderCloseButton>
                </ModalHeader>

                {step === "form" ? (
                    <ChangePasswordForm onSuccess={() => setStep("confirmation")} />
                ) : (
                    <ChangePasswordConfirmation close={props.handleClose} />
                )}
            </ModalBody>
        </ModalOverlay>
    );
};

export default ChangePasswordGroup;